import { render, staticRenderFns } from "./Lei.vue?vue&type=template&id=0d878315&scoped=true&"
import script from "./Lei.vue?vue&type=script&lang=js&"
export * from "./Lei.vue?vue&type=script&lang=js&"
import style0 from "./Lei.vue?vue&type=style&index=0&id=0d878315&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d878315",
  null
  
)

export default component.exports